const ACCESS_TOKEN_KEY = "lf.accessToken";
const REFRESH_TOKEN_KEY = "lf.refreshToken";

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

/**
 * The browser-local home of the access/refresh token pair. Every reader and
 * writer of the pair goes through this entity, so the storage keys and the
 * "both tokens move together" rule live in exactly one place.
 */
export class TokenStorage {
  public static getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  public static getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  public static setTokens(tokens: TokenPair): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  }

  public static clearTokens(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}
